import { render, staticRenderFns } from "./VpsSwitcher.vue?vue&type=template&id=a2170e9c&scoped=true&"
import script from "./VpsSwitcher.vue?vue&type=script&lang=js&"
export * from "./VpsSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2170e9c",
  null
  
)

export default component.exports